import React, { useState } from "react";
import { useBnbSelector } from "../../../redux/store";
import * as Styles from "./styles/GradeEngineOverviewStyles";
import DisclaimerContainer from "../common/disclaimer/DisclaimerContainer";
import FinanceToggle from "../common/FinanceToggle";
import { GradeBlock } from "./GradeBlock";
import { useBnbLabel } from "../../../utils/labels";
import { GreyBackground } from "../../../../../../common-deprecated/styles/v2/toyota/utilities/Background";

const GradesOverview = (): JSX.Element => {
    const model = useBnbSelector((state) => state.model);
    const modelGrades = useBnbSelector((state) => state.model.grades);

    const titleLabel = useBnbLabel("chooseYourGrade", { model: model.name });
    const [selectedGrade, setSelectedGrade] = useState<string>("");

    return (
        <GreyBackground>
            <Styles.Wrapper>
                <div>
                    <Styles.Header>
                        <Styles.Title>{titleLabel}</Styles.Title>
                        <FinanceToggle modelCode={model.internalCode} />
                    </Styles.Header>
                </div>
                {modelGrades.map((grade) => (
                    <GradeBlock
                        key={`${model.id}-${grade.id}-${grade.bodyType.id}`}
                        grade={grade}
                        isSelected={selectedGrade === grade.id}
                        setSelected={setSelectedGrade}
                    />
                ))}
                <DisclaimerContainer hasDarkBackground />
            </Styles.Wrapper>
        </GreyBackground>
    );
};

export default GradesOverview;
